var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.354 5.752A18.348 18.348 0 0019.34.362c-4.71 0-9.42 1.797-13.012 5.39-7.187 7.187-7.187 18.838 0 26.025a18.338 18.338 0 0013.012 5.39c4.71 0 9.421-1.795 13.014-5.39 7.187-7.187 7.187-18.838 0-26.025",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.341 8.988a2.69 2.69 0 100 5.38 2.69 2.69 0 000-5.38M16.884 28.542h4.913V16.399h-4.913z",
    fill: "#FFFFFE"
  }))));
}
export default __webpack_public_path__ + "1a0f9bf6136e0517d79c6cc69140c638.svg";
export { SvgInfoIcon as ReactComponent };